import {Pipe, PipeTransform} from '@angular/core';
import {StateStat} from '@app/core/model/geo';

@Pipe({
    name: 'stateCoverage'
})
export class StateCoveragePipe implements PipeTransform {

    transform(numberOfOrgs: number, stats: StateStat): string {
        return (numberOfOrgs && stats && stats.districts) ? Math.round(numberOfOrgs * 100 / stats.districts) + '%' : '';
    }

}
